/**
 * IvCert
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable, of } from 'rxjs';
import { CircuitTypeAdminRequest } from '../model/circuitTypeAdminRequest';
import { CustomizationRequest } from '../model/customizationRequest';
import { IvGenericRestResponseBoolean } from '../model/ivGenericRestResponseBoolean';
import { IvGenericRestResponseCircuitTypeResponse } from '../model/ivGenericRestResponseCircuitTypeResponse';
import { PageResultCircuitAdminBean } from '../model/pageResultCircuitAdminBean';
import { PageResultCircuitTypeAdmin } from '../model/pageResultCircuitTypeAdmin';
import { PageResultCustomizationResponse } from '../model/pageResultCustomizationResponse';
import { PageResultOrganization } from '../model/pageResultOrganization';
import { PageResultListCustomizations } from '../model/pageResultListCustomizations';
import { Configuration } from '../configuration';
import { DateParser } from '../date';
import { IvCertGenericResponseListAreaP } from '../model/ivCertGenericResponseListAreaP';
import { IvCertGenericResponseListCargo } from '../model/ivCertGenericResponseListCargo';
import { IvCertGenericResponseOrganizationUserP } from '../model/ivCertGenericResponseOrganizationUserP';
import { IvGenericRestResponseListOrganizationPhonePrefix, OrganizationPhonePrefix, OrganizationUserQ } from '../model/models';
import { OrganizationUserP } from '../model/organizationUserP';
import { BASE_PATH } from '../variables';
import { IvCertGenericResponseOrganizationPutAdmin } from '../model/ivCertGenericResponseOrganizationPutAdmin';
import { IvCertGenericResponseListOperationP } from '../model/ivCertGenericResponseListOperationP';
import { IvCertGenericResponseListCircuitDocumentP } from '../model/ivCertGenericResponseListCircuitDocumentP';
import { IvCertGenericResponseCircuit } from '../model/ivCertGenericResponseCircuit';
import { IvCertGenericResponseRelationOperationCredits } from '../model/ivCertGenericResponseRelationOperationCredits';
import { IvCertGenericResponseListIvcertTypeTemplate } from '../model/ivCertGenericResponseListIvcertTypeTemplate';
import { IvCertGenericResponseListOperationType } from '../model/ivCertGenericResponseListOperationType';
import { IvCertGenericResponseListAdminTypesCircuits } from '../model/ivCertGenericResponseListAdminTypesCircuits';
import { IvCertGenericResponseListAdminOrga } from '../model/ivCertGenericResponseListAdminOrga';
import { IvCertGenericResponseAdminRequestPostTemplate } from '../model/ivCertGenericResponseAdminRequestPostTemplate';
import { AdminRequestPostTemplate } from '../model/adminRequestPostTemplate';
import { IvCertGenericResponseIvcertTemplates } from '../model/ivCertGenericResponseIvcertTemplates';
import { IvCertGenericResponseListListCustomizationTemplates } from '../model/ivCertGenericResponseListListCustomizationTemplates';
import { IvCertGenericResponseBoolean } from '../model/ivCertGenericResponseBoolean';
import { CustomCircuitCreateAdmin } from '../model/customCircuitCreateAdmin';
import { IvCertGenericResponseCustomCircuitCreateAdmin } from '../model/ivCertGenericResponseCustomCircuitCreateAdmin';
import { IvCertGenericResponseListCustomizationParentCircAdmin } from '../model/ivCertGenericResponseListCustomizationParentCircAdmin';
import { IvCertGenericResponseCustomizationRequest } from '../model/ivCertGenericResponseCustomizationRequest';
import { IvGenericRestResponseCircuitTypeAdminRequest } from '../model/ivGenericRestResponseCircuitTypeAdminRequest';
import { IvCertGenericResponseListCertsOrga } from '../model/ivCertGenericResponseListCertsOrga';
import { IvGenericRestResponseOrganizationPhonePrefix } from '../model/ivGenericRestResponseOrganizationPhonePrefix';
import { IvCertGenericResponseAccessRestrictions } from '../model/ivCertGenericResponseAccessRestrictions';
import { AccessRestrictions } from '../model/accessRestrictions';
import { IvGenericRestResponseAccessRestrictions } from '../model/ivGenericRestResponseAccessRestrictions';
import { IvCertGenericResponseListOrgaAccessLogin } from '../model/ivCertGenericResponseListOrgaAccessLogin';
import { UserCreator } from '../model/userCreator';
import { IvGenericRestResponseListCircuitTypeListResponse } from '../model/ivGenericRestResponseListCircuitTypeListResponse';
import { OrganizationPutAdmin } from '../model/organizationPutAdmin';
import { OrganizationPostAdmin } from '../model/organizationPostAdmin';
import { PersonalizationsService } from '../../base/services/personalizations/personalizations.service';
import { Environment } from '../../models/environment';
import { tap } from 'rxjs/operators';
import { PostWidgetRequest } from '../model/postWidgetRequest';
import { IvCertGenericResponseGetWidgetResponse } from '../model/ivCertGenericResponseGetWidgetResponse';
import { PutWidgetRequest } from '../model/putWidgetRequest';
import { PageResultItemTermAndConditionResponse } from '../model/pageResultItemTermAndConditionResponse';
import { CreateTermAndConditionRequest } from '../model/createTermAndConditionRequest';
import { IvCertGenericResponseGetTermAndConditionResponse } from '../model/ivCertGenericResponseGetTermAndConditionResponse';
import { UpdateTermAndConditionRequest } from '../model/updateTermAndConditionRequest';
import { IvCertGenericResponseIEnumerableString } from '../model/ivCertGenericResponseIEnumerableString';
import { IvCertGenericResponseGetSignatureTypeResponse } from '../model/ivCertGenericResponseGetSignatureTypeResponse';
import { CreateSignatureTypeRequest } from '../model/createSignatureTypeRequest';
import { UpdateSignatureTypeRequest } from '../model/updateSignatureTypeRequest';
import { IvCertGenericResponseIListItemSignatureTypesByTypeDocResponse } from '../model/ivCertGenericResponseIListItemSignatureTypesByTypeDocResponse';
import { PageResultItemSignatureCertificateResponse } from '../model/pageResultItemSignatureCertificateResponse';
import { IvCertGenericResponseItemSignatureCertificateResponse } from '../model/ivCertGenericResponseItemSignatureCertificateResponse';
import { SigorgaCerts } from '../model/sigorgaCerts';
import { IvCertGenericResponseSigorgaCerts } from '../model/ivCertGenericResponseSigorgaCerts';
import { IvCertGenericResponseListString } from '../model/ivCertGenericResponseListString';
import { UpdateOrganizationSenderRequest } from '../model/updateOrganizationSenderRequest';
import { CreateOrganizationSenderRequest } from '../model/createOrganizationSenderRequest';
import { PageResultItemOrganizationSenderResponse } from '../model/pageResultItemOrganizationSenderResponse';
import { UpdateReprocessCallbackPolicyRequest } from '../model/updateReprocessCallbackPolicyRequest';
import { CreateReprocessCallbackPolicyRequest } from '../model/createReprocessCallbackPolicyRequest';
import { IvCertGenericResponseItemReprocessCallbackPolicyResponse } from '../model/ivCertGenericResponseItemReprocessCallbackPolicyResponse';
import { PageResultItemReprocessCallbackPolicyResponse } from '../model/pageResultItemReprocessCallbackPolicyResponse';
import { IvCertGenericResponseItemOrganizationSenderResponse } from '../model/ivCertGenericResponseItemOrganizationSenderResponse';
import { EnvironmentService } from './environment.service';


@Injectable()
export class AdminService {

    environment: Environment;
    protected basePath: string;
    protected apiVersion: string;
    public defaultHeaders = new HttpHeaders().set('timeClient', DateParser.parse(new Date()));
    public configuration = new Configuration();

    prefixesCache$: Observable<IvGenericRestResponseListOrganizationPhonePrefix>;

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration, private _personalization: PersonalizationsService, private _env: EnvironmentService) {
        this.environment = this._personalization.sendEnv;
        this.apiVersion = this._env.apiVersion;
        this.basePath = this.environment?.url_api;
        this.defaultHeaders = this.defaultHeaders.set('X-Request-ID', 'app-front');
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * Eliminar tipo de circuito.
     *
     * @param idAplicacion Identificador del tipo de circuito
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminDeleteCircuitType(idAplicacion: string, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseBoolean>;
    public adminDeleteCircuitType(idAplicacion: string, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseBoolean>>;
    public adminDeleteCircuitType(idAplicacion: string, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseBoolean>>;
    public adminDeleteCircuitType(idAplicacion: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idAplicacion === null || idAplicacion === undefined) {
            throw new Error('Required parameter idAplicacion was null or undefined when calling adminDeleteCircuitType.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminDeleteCircuitType.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idAplicacion !== undefined && idAplicacion !== null) {
            queryParameters = queryParameters.set('idAplicacion', <any>idAplicacion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.delete<IvGenericRestResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/CircuitType`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
    * Delete customization
    *
    * @param appId AppId customization
    * @param authorization The authorization token
    * @param apiVersion
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public adminDeleteCustomization(appId: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminDeleteCustomization(appId: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminDeleteCustomization(appId: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminDeleteCustomization(appId: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling adminDeleteCustomization.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminDeleteCustomization.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (appId !== undefined && appId !== null) {
            queryParameters = queryParameters.set('appId', <any>appId);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.delete<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/Customization`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Eliminar una organización
     *
     * @param id Identificador interno de la organización a eliminar
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminDeleteOrganization(id: string, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseBoolean>;
    public adminDeleteOrganization(id: string, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseBoolean>>;
    public adminDeleteOrganization(id: string, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseBoolean>>;
    public adminDeleteOrganization(id: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling adminDeleteOrganization.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminDeleteOrganization.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.delete<IvGenericRestResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/Organization/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param idOrg
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetListSigOrgaCertificates(idOrg: number, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListCertsOrga>;
    public adminGetListSigOrgaCertificates(idOrg: number, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListCertsOrga>>;
    public adminGetListSigOrgaCertificates(idOrg: number, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListCertsOrga>>;
    public adminGetListSigOrgaCertificates(idOrg: number, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idOrg === null || idOrg === undefined) {
            throw new Error('Required parameter idOrg was null or undefined when calling adminGetListSigOrgaCertificates.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetListSigOrgaCertificates.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOrg !== undefined && idOrg !== null) {
            queryParameters = queryParameters.set('idOrg', <any>idOrg);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListCertsOrga>(`${this.basePath}/api/${this.apiVersion}/Admin/getSigOrgaCertificatesAdmin`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elimina usuario
     *
     * @param id
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminDeleteUser(id: number, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseBoolean>;
    public adminDeleteUser(id: number, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseBoolean>>;
    public adminDeleteUser(id: number, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseBoolean>>;
    public adminDeleteUser(id: number, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling adminDeleteUser.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminDeleteUser.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.delete<IvGenericRestResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/User/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param idCircuit
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetAuditCircuitPDFSysAdmin(idCircuit: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public adminGetAuditCircuitPDFSysAdmin(idCircuit: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public adminGetAuditCircuitPDFSysAdmin(idCircuit: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public adminGetAuditCircuitPDFSysAdmin(idCircuit: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idCircuit === null || idCircuit === undefined) {
            throw new Error('Required parameter idCircuit was null or undefined when calling adminGetAuditCircuitPDFSysAdmin.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetAuditCircuitPDFSysAdmin.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idCircuit !== undefined && idCircuit !== null) {
            queryParameters = queryParameters.set('idCircuit', <any>idCircuit);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get(`${this.basePath}/api/${this.apiVersion}/Admin/AuditCircuitPDF`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     * Get circuit type by idAplication
     *
     * @param idAplicacion Circuit type identifier
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetCircuit(idAplicacion: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseCircuitTypeAdminRequest>;
    public adminGetCircuit(idAplicacion: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseCircuitTypeAdminRequest>>;
    public adminGetCircuit(idAplicacion: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseCircuitTypeAdminRequest>>;
    public adminGetCircuit(idAplicacion: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idAplicacion === null || idAplicacion === undefined) {
            throw new Error('Required parameter idAplicacion was null or undefined when calling adminGetCircuit.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetCircuit.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idAplicacion !== undefined && idAplicacion !== null) {
            queryParameters = queryParameters.set('idAplicacion', <any>idAplicacion);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvGenericRestResponseCircuitTypeAdminRequest>(`${this.basePath}/api/${this.apiVersion}/Admin/GetCircuit`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param authorization The authorization token
     * @param idCircuit
     * @param externalIdCircuit
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetCircuitEvidenceSysAdmin(authorization: string, idCircuit?: string, externalIdCircuit?: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public adminGetCircuitEvidenceSysAdmin(authorization: string, idCircuit?: string, externalIdCircuit?: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public adminGetCircuitEvidenceSysAdmin(authorization: string, idCircuit?: string, externalIdCircuit?: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public adminGetCircuitEvidenceSysAdmin(authorization: string, idCircuit?: string, externalIdCircuit?: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetCircuitEvidenceSysAdmin.');
        }




        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idCircuit !== undefined && idCircuit !== null) {
            queryParameters = queryParameters.set('idCircuit', <any>idCircuit);
        }
        if (externalIdCircuit !== undefined && externalIdCircuit !== null) {
            queryParameters = queryParameters.set('externalIdCircuit', <any>externalIdCircuit);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get(`${this.basePath}/api/${this.apiVersion}/Admin/CircuitEvidenceSysAdmin`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     *
     *
     * @param authorization The authorization token
     * @param idCircuit
     * @param externalId
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetCircuitSysAdmin(authorization: string, idCircuit?: string, externalId?: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseCircuit>;
    public adminGetCircuitSysAdmin(authorization: string, idCircuit?: string, externalId?: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseCircuit>>;
    public adminGetCircuitSysAdmin(authorization: string, idCircuit?: string, externalId?: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseCircuit>>;
    public adminGetCircuitSysAdmin(authorization: string, idCircuit?: string, externalId?: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetCircuitSysAdmin.');
        }




        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idCircuit !== undefined && idCircuit !== null) {
            queryParameters = queryParameters.set('idCircuit', <any>idCircuit);
        }
        if (externalId !== undefined && externalId !== null) {
            queryParameters = queryParameters.set('externalId', <any>externalId);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseCircuit>(`${this.basePath}/api/${this.apiVersion}/Admin/GetCircuitSysAdmin`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get list of circuit
     *
     * @param authorization The authorization token
     * @param apiVersion
     * @param top The max number of records. (e.g. $top&#x3D;10)
     * @param skip The number of records to skip. (e.g. $skip&#x3D;5)
     * @param filter A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq &#39;bob&#39;)
     * @param select Specifies a subset of properties to return. (e.g. $select&#x3D;Name)
     * @param inlinecount Tells the server to include the total count of matching entities in the response. (e.g. $inlinecount&#x3D;allpages)
     * @param orderby Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetCircuits(authorization: string, apiVersion?: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'body', reportProgress?: boolean): Observable<PageResultCircuitAdminBean>;
    public adminGetCircuits(authorization: string, apiVersion?: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageResultCircuitAdminBean>>;
    public adminGetCircuits(authorization: string, apiVersion?: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageResultCircuitAdminBean>>;
    public adminGetCircuits(authorization: string, apiVersion?: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetCircuits.');
        }








        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }
        if (top !== undefined && top !== null) {
            queryParameters = queryParameters.set('$top', <any>top);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('$skip', <any>skip);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>filter);
        }
        if (select !== undefined && select !== null) {
            queryParameters = queryParameters.set('$select', <any>select);
        }
        if (inlinecount !== undefined && inlinecount !== null) {
            queryParameters = queryParameters.set('$inlinecount', <any>inlinecount);
        }
        if (orderby !== undefined && orderby !== null) {
            queryParameters = queryParameters.set('$orderby', <any>orderby);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<PageResultCircuitAdminBean>(`${this.basePath}/api/${this.apiVersion}/Admin/GetCircuits`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get customization by AppID
     *
     * @param appid AppId
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetCustomization(appid: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseCustomizationRequest>;
    public adminGetCustomization(appid: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseCustomizationRequest>>;
    public adminGetCustomization(appid: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseCustomizationRequest>>;
    public adminGetCustomization(appid: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (appid === null || appid === undefined) {
            throw new Error('Required parameter appid was null or undefined when calling adminGetCustomization.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetCustomization.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (appid !== undefined && appid !== null) {
            queryParameters = queryParameters.set('appid', <any>appid);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseCustomizationRequest>(`${this.basePath}/api/${this.apiVersion}/Admin/Customization`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param idCircuit
     * @param idDocument
     * @param authorization The authorization token
     * @param appId
     * @param idOperation
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    async adminGetDownloadDocumentCircuitSysAdmin(idCircuit: string, idDocument: string, authorization: string, appId?: string, observe?: 'body', idOperation?: string, apiVersion?: string, reportProgress?: boolean): Promise<any>;
    async adminGetDownloadDocumentCircuitSysAdmin(idCircuit: string, idDocument: string, authorization: string, appId?: string, observe?: 'response', idOperation?: string, apiVersion?: string, reportProgress?: boolean): Promise<HttpResponse<any>>;
    async adminGetDownloadDocumentCircuitSysAdmin(idCircuit: string, idDocument: string, authorization: string, appId?: string, observe?: 'events', idOperation?: string, apiVersion?: string, reportProgress?: boolean): Promise<HttpEvent<any>>;
    async adminGetDownloadDocumentCircuitSysAdmin(idCircuit: string, idDocument: string, authorization: string, appId?: string, observe: any = 'body', idOperation?: string, apiVersion?: string, reportProgress: boolean = false): Promise<any> {

        if (idCircuit === null || idCircuit === undefined) {
            throw new Error('Required parameter idCircuit was null or undefined when calling adminGetDownloadDocumentCircuitSysAdmin.');
        }

        if (idDocument === null || idDocument === undefined) {
            throw new Error('Required parameter idDocument was null or undefined when calling adminGetDownloadDocumentCircuitSysAdmin.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetDownloadDocumentCircuitSysAdmin.');
        }




        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idCircuit !== undefined && idCircuit !== null) {
            queryParameters = queryParameters.set('idCircuit', <any>idCircuit);
        }
        if (idDocument !== undefined && idDocument !== null) {
            queryParameters = queryParameters.set('idDocument', <any>idDocument);
        }
        if (appId !== undefined && appId !== null) {
            queryParameters = queryParameters.set('appId', <any>appId);
        }
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return await this.httpClient.get(`${this.basePath}/api/${this.apiVersion}/Admin/DownloadDocumentCircuitSysAdmin`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        ).toPromise();
    }

    /**
     *
     *
     * @param idEvidence
     * @param idCircuit
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetDownloadEvidenceSysAdmin(idEvidence: string, idCircuit: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public adminGetDownloadEvidenceSysAdmin(idEvidence: string, idCircuit: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public adminGetDownloadEvidenceSysAdmin(idEvidence: string, idCircuit: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public adminGetDownloadEvidenceSysAdmin(idEvidence: string, idCircuit: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idEvidence === null || idEvidence === undefined) {
            throw new Error('Required parameter idEvidence was null or undefined when calling adminGetDownloadEvidenceSysAdmin.');
        }

        if (idCircuit === null || idCircuit === undefined) {
            throw new Error('Required parameter idCircuit was null or undefined when calling adminGetDownloadEvidenceSysAdmin.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetDownloadEvidenceSysAdmin.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idEvidence !== undefined && idEvidence !== null) {
            queryParameters = queryParameters.set('idEvidence', <any>idEvidence);
        }
        if (idCircuit !== undefined && idCircuit !== null) {
            queryParameters = queryParameters.set('idCircuit', <any>idCircuit);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get(`${this.basePath}/api/${this.apiVersion}/Admin/DownloadEvidenceSysAdmin`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     *
     *
     * @param idEvidence
     * @param idCircuit
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetEvidencePDFSysAdmin(idEvidence: string, idCircuit: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public adminGetEvidencePDFSysAdmin(idEvidence: string, idCircuit: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public adminGetEvidencePDFSysAdmin(idEvidence: string, idCircuit: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public adminGetEvidencePDFSysAdmin(idEvidence: string, idCircuit: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idEvidence === null || idEvidence === undefined) {
            throw new Error('Required parameter idEvidence was null or undefined when calling adminGetEvidencePDFSysAdmin.');
        }

        if (idCircuit === null || idCircuit === undefined) {
            throw new Error('Required parameter idCircuit was null or undefined when calling adminGetEvidencePDFSysAdmin.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetEvidencePDFSysAdmin.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idEvidence !== undefined && idEvidence !== null) {
            queryParameters = queryParameters.set('idEvidence', <any>idEvidence);
        }
        if (idCircuit !== undefined && idCircuit !== null) {
            queryParameters = queryParameters.set('idCircuit', <any>idCircuit);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get(`${this.basePath}/api/${this.apiVersion}/Admin/EvidencePDFSysAdmin`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     * Devuelve el listado de tipos de circuitos creados en el entorno
     *
     * @param authorization The authorization token
     * @param top The max number of records. (e.g. $top&#x3D;10)
     * @param skip The number of records to skip. (e.g. $skip&#x3D;5)
     * @param filter A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq &#39;bob&#39;)
     * @param select Specifies a subset of properties to return. (e.g. $select&#x3D;Name)
     * @param inlinecount Tells the server to include the total count of matching entities in the response. (e.g. $inlinecount&#x3D;allpages)
     * @param orderby Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetListCircuitType(authorization?: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'body', reportProgress?: boolean): Observable<PageResultCircuitTypeAdmin>;
    public adminGetListCircuitType(authorization?: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageResultCircuitTypeAdmin>>;
    public adminGetListCircuitType(authorization?: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageResultCircuitTypeAdmin>>;
    public adminGetListCircuitType(authorization?: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {









        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (top !== undefined && top !== null) {
            queryParameters = queryParameters.set('$top', <any>top);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('$skip', <any>skip);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>filter);
        }
        if (select !== undefined && select !== null) {
            queryParameters = queryParameters.set('$select', <any>select);
        }
        if (inlinecount !== undefined && inlinecount !== null) {
            queryParameters = queryParameters.set('$inlinecount', <any>inlinecount);
        }
        if (orderby !== undefined && orderby !== null) {
            queryParameters = queryParameters.set('$orderby', <any>orderby);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<PageResultCircuitTypeAdmin>(`${this.basePath}/api/${this.apiVersion}/Admin/ListCircuitType`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Devuelve el listado de personalizaciones
     *
     * @param authorization The authorization token
     * @param top The max number of records. (e.g. $top&#x3D;10)
     * @param skip The number of records to skip. (e.g. $skip&#x3D;5)
     * @param filter A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq &#39;bob&#39;)
     * @param select Specifies a subset of properties to return. (e.g. $select&#x3D;Name)
     * @param inlinecount Tells the server to include the total count of matching entities in the response. (e.g. $inlinecount&#x3D;allpages)
     * @param orderby Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetListCustomizations(authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'body', reportProgress?: boolean): Observable<PageResultCustomizationResponse>;
    public adminGetListCustomizations(authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageResultCustomizationResponse>>;
    public adminGetListCustomizations(authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageResultCustomizationResponse>>;
    public adminGetListCustomizations(authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetListCustomizations.');
        }







        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (top !== undefined && top !== null) {
            queryParameters = queryParameters.set('$top', <any>top);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('$skip', <any>skip);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>filter);
        }
        if (select !== undefined && select !== null) {
            queryParameters = queryParameters.set('$select', <any>select);
        }
        if (inlinecount !== undefined && inlinecount !== null) {
            queryParameters = queryParameters.set('$inlinecount', <any>inlinecount);
        }
        if (orderby !== undefined && orderby !== null) {
            queryParameters = queryParameters.set('$orderby', <any>orderby);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<PageResultCustomizationResponse>(`${this.basePath}/api/${this.apiVersion}/Admin/ListCustomizations`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


    /**
     * Get listado Personalizaciones
     *
     * @param authorization The authorization token
     * @param apiVersion
     * @param top The max number of records. (e.g. $top&#x3D;10)
     * @param skip The number of records to skip. (e.g. $skip&#x3D;5)
     * @param filter A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq &#39;bob&#39;)
     * @param select Specifies a subset of properties to return. (e.g. $select&#x3D;Name)
     * @param inlinecount Tells the server to include the total count of matching entities in the response. (e.g. $inlinecount&#x3D;allpages)
     * @param orderby Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetListCustomizations_1(authorization: string, apiVersion?: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'body', reportProgress?: boolean): Observable<PageResultListCustomizations>;
    public adminGetListCustomizations_1(authorization: string, apiVersion?: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageResultListCustomizations>>;
    public adminGetListCustomizations_1(authorization: string, apiVersion?: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageResultListCustomizations>>;
    public adminGetListCustomizations_1(authorization: string, apiVersion?: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetListCustomizations_1.');
        }








        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }
        if (top !== undefined && top !== null) {
            queryParameters = queryParameters.set('$top', <any>top);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('$skip', <any>skip);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>filter);
        }
        if (select !== undefined && select !== null) {
            queryParameters = queryParameters.set('$select', <any>select);
        }
        if (inlinecount !== undefined && inlinecount !== null) {
            queryParameters = queryParameters.set('$inlinecount', <any>inlinecount);
        }
        if (orderby !== undefined && orderby !== null) {
            queryParameters = queryParameters.set('$orderby', <any>orderby);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<PageResultListCustomizations>(`${this.basePath}/api/${this.apiVersion}/Admin/GetListCustomizations`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param authorization The authorization token
     * @param idCircuit
     * @param externalIdCircuit
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetListDocumentsCircuitSysAdmin(authorization: string, idCircuit?: string, externalIdCircuit?: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListCircuitDocumentP>;
    public adminGetListDocumentsCircuitSysAdmin(authorization: string, idCircuit?: string, externalIdCircuit?: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListCircuitDocumentP>>;
    public adminGetListDocumentsCircuitSysAdmin(authorization: string, idCircuit?: string, externalIdCircuit?: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListCircuitDocumentP>>;
    public adminGetListDocumentsCircuitSysAdmin(authorization: string, idCircuit?: string, externalIdCircuit?: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetListDocumentsCircuitSysAdmin.');
        }




        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idCircuit !== undefined && idCircuit !== null) {
            queryParameters = queryParameters.set('idCircuit', <any>idCircuit);
        }
        if (externalIdCircuit !== undefined && externalIdCircuit !== null) {
            queryParameters = queryParameters.set('externalIdCircuit', <any>externalIdCircuit);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListCircuitDocumentP>(`${this.basePath}/api/${this.apiVersion}/Admin/ListDocumentsCircuitSysAdmin`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtener listado de las organizaciones
     *
     * @param authorization The authorization token
     * @param top The max number of records. (e.g. $top&#x3D;10)
     * @param skip The number of records to skip. (e.g. $skip&#x3D;5)
     * @param filter A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq &#39;bob&#39;)
     * @param select Specifies a subset of properties to return. (e.g. $select&#x3D;Name)
     * @param inlinecount Tells the server to include the total count of matching entities in the response. (e.g. $inlinecount&#x3D;allpages)
     * @param orderby Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetListOrgs(authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'body', reportProgress?: boolean): Observable<PageResultOrganization>;
    public adminGetListOrgs(authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageResultOrganization>>;
    public adminGetListOrgs(authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageResultOrganization>>;
    public adminGetListOrgs(authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetListOrgs.');
        }







        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (top !== undefined && top !== null) {
            queryParameters = queryParameters.set('$top', <any>top);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('$skip', <any>skip);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>filter);
        }
        if (select !== undefined && select !== null) {
            queryParameters = queryParameters.set('$select', <any>select);
        }
        if (inlinecount !== undefined && inlinecount !== null) {
            queryParameters = queryParameters.set('$inlinecount', <any>inlinecount);
        }
        if (orderby !== undefined && orderby !== null) {
            queryParameters = queryParameters.set('$orderby', <any>orderby);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<PageResultOrganization>(`${this.basePath}/api/${this.apiVersion}/Admin/ListOrgs`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crear un tipo de circuito nuevo
     *
     * @param request
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPostCircuitType(request: CircuitTypeAdminRequest, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseCircuitTypeResponse>;
    public adminPostCircuitType(request: CircuitTypeAdminRequest, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseCircuitTypeResponse>>;
    public adminPostCircuitType(request: CircuitTypeAdminRequest, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseCircuitTypeResponse>>;
    public adminPostCircuitType(request: CircuitTypeAdminRequest, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling adminPostCircuitType.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPostCircuitType.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvGenericRestResponseCircuitTypeResponse>(`${this.basePath}/api/${this.apiVersion}/Admin/CircuitType`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create new customization
     *
     * @param customization Information for customization
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPostCustomization(customization: CustomizationRequest, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseBoolean>;
    public adminPostCustomization(customization: CustomizationRequest, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseBoolean>>;
    public adminPostCustomization(customization: CustomizationRequest, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseBoolean>>;
    public adminPostCustomization(customization: CustomizationRequest, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (customization === null || customization === undefined) {
            throw new Error('Required parameter customization was null or undefined when calling adminPostCustomization.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPostCustomization.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvGenericRestResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/Customization`,
            customization,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create new organization SysAdmin
     *
     * @param organization Objeto tipo Organization
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPostOrganization(organization: OrganizationPostAdmin, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminPostOrganization(organization: OrganizationPostAdmin, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminPostOrganization(organization: OrganizationPostAdmin, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminPostOrganization(organization: OrganizationPostAdmin, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (organization === null || organization === undefined) {
            throw new Error('Required parameter organization was null or undefined when calling adminPostOrganization.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPostOrganization.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/Organization`,
            organization,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea usuario
     *
     * @param usuario
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPostUser(user: OrganizationUserP, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseOrganizationUserP>;
    public adminPostUser(user: OrganizationUserP, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseOrganizationUserP>>;
    public adminPostUser(user: OrganizationUserP, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseOrganizationUserP>>;
    public adminPostUser(user: OrganizationUserP, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (user === null || user === undefined) {
            throw new Error('Required parameter user was null or undefined when calling adminPostUser.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPostUser.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvCertGenericResponseOrganizationUserP>(`${this.basePath}/api/${this.apiVersion}/Admin/User`,
            user,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Actualizar datos del tipo de circuito
     *
     * @param request Objeto tipo CircuitTypeRequest
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPutCircuitType(request: CircuitTypeAdminRequest, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseCircuitTypeResponse>;
    public adminPutCircuitType(request: CircuitTypeAdminRequest, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseCircuitTypeResponse>>;
    public adminPutCircuitType(request: CircuitTypeAdminRequest, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseCircuitTypeResponse>>;
    public adminPutCircuitType(request: CircuitTypeAdminRequest, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling adminPutCircuitType.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPutCircuitType.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<IvGenericRestResponseCircuitTypeResponse>(`${this.basePath}/api/${this.apiVersion}/Admin/CircuitType`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param customization
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPutCustomization(customization: CustomizationRequest, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminPutCustomization(customization: CustomizationRequest, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminPutCustomization(customization: CustomizationRequest, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminPutCustomization(customization: CustomizationRequest, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (customization === null || customization === undefined) {
            throw new Error('Required parameter customization was null or undefined when calling adminPutCustomization.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPutCustomization.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/Customization`,
            customization,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modify organization SysAdmin
     *
     * @param organization Objeto tipo Organization
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPutOrganization(organization: OrganizationPutAdmin, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminPutOrganization(organization: OrganizationPutAdmin, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminPutOrganization(organization: OrganizationPutAdmin, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminPutOrganization(organization: OrganizationPutAdmin, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (organization === null || organization === undefined) {
            throw new Error('Required parameter organization was null or undefined when calling adminPutOrganization.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPutOrganization.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/Organization`,
            organization,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
       *
       *
       * @param authorization The authorization token
       * @param appid
       * @param apiVersion
       * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
       * @param reportProgress flag to report request and response progress.
       */
    public adminGetParentsCustomizationsSysdamin(authorization: string, appid?: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListCustomizationParentCircAdmin>;
    public adminGetParentsCustomizationsSysdamin(authorization: string, appid?: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListCustomizationParentCircAdmin>>;
    public adminGetParentsCustomizationsSysdamin(authorization: string, appid?: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListCustomizationParentCircAdmin>>;
    public adminGetParentsCustomizationsSysdamin(authorization: string, appid?: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetParentsCustomizationsSysdamin.');
        }



        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (appid !== undefined && appid !== null) {
            queryParameters = queryParameters.set('appid', <any>appid);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListCustomizationParentCircAdmin>(`${this.basePath}/api/${this.apiVersion}/Admin/ListCustomizationParents`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


    /**
     *
     *
     * @param customCircuit
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPostCustomCircuitSysAdmin(customCircuit: CustomCircuitCreateAdmin, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseCustomCircuitCreateAdmin>;
    public adminPostCustomCircuitSysAdmin(customCircuit: CustomCircuitCreateAdmin, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseCustomCircuitCreateAdmin>>;
    public adminPostCustomCircuitSysAdmin(customCircuit: CustomCircuitCreateAdmin, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseCustomCircuitCreateAdmin>>;
    public adminPostCustomCircuitSysAdmin(customCircuit: CustomCircuitCreateAdmin, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (customCircuit === null || customCircuit === undefined) {
            throw new Error('Required parameter customCircuit was null or undefined when calling adminPostCustomCircuitSysAdmin.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPostCustomCircuitSysAdmin.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvCertGenericResponseCustomCircuitCreateAdmin>(`${this.basePath}/api/${this.apiVersion}/Admin/CustomCircuit`,
            customCircuit,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


    /**
     *
     *
     * @param idCustomCircuit
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
    */
    public adminDeleteCustomCircuitSysAdmin(idCustomCircuit: number, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminDeleteCustomCircuitSysAdmin(idCustomCircuit: number, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminDeleteCustomCircuitSysAdmin(idCustomCircuit: number, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminDeleteCustomCircuitSysAdmin(idCustomCircuit: number, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idCustomCircuit === null || idCustomCircuit === undefined) {
            throw new Error('Required parameter idCustomCircuit was null or undefined when calling adminDeleteCustomCircuitSysAdmin.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminDeleteCustomCircuitSysAdmin.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idCustomCircuit !== undefined && idCustomCircuit !== null) {
            queryParameters = queryParameters.set('idCustomCircuit', <any>idCustomCircuit);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.delete<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/CustomCircuit`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get custom circuit for SysAdmin user
     *
     * @param codeCircuit
     * @param idOrg
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetCustomCircuitSysAdmin(codeCircuit: string, idOrg: number, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseCustomCircuitCreateAdmin>;
    public adminGetCustomCircuitSysAdmin(codeCircuit: string, idOrg: number, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseCustomCircuitCreateAdmin>>;
    public adminGetCustomCircuitSysAdmin(codeCircuit: string, idOrg: number, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseCustomCircuitCreateAdmin>>;
    public adminGetCustomCircuitSysAdmin(codeCircuit: string, idOrg: number, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (codeCircuit === null || codeCircuit === undefined) {
            throw new Error('Required parameter codeCircuit was null or undefined when calling adminGetCustomCircuitSysAdmin.');
        }

        if (idOrg === null || idOrg === undefined) {
            throw new Error('Required parameter idOrg was null or undefined when calling adminGetCustomCircuitSysAdmin.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetCustomCircuitSysAdmin.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (codeCircuit !== undefined && codeCircuit !== null) {
            queryParameters = queryParameters.set('codeCircuit', <any>codeCircuit);
        }
        if (idOrg !== undefined && idOrg !== null) {
            queryParameters = queryParameters.set('idOrg', <any>idOrg);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseCustomCircuitCreateAdmin>(`${this.basePath}/api/${this.apiVersion}/Admin/CustomCircuit`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param customCircuit
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPutCustomCircuitSysAdmin(customCircuit: CustomCircuitCreateAdmin, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseCustomCircuitCreateAdmin>;
    public adminPutCustomCircuitSysAdmin(customCircuit: CustomCircuitCreateAdmin, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseCustomCircuitCreateAdmin>>;
    public adminPutCustomCircuitSysAdmin(customCircuit: CustomCircuitCreateAdmin, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseCustomCircuitCreateAdmin>>;
    public adminPutCustomCircuitSysAdmin(customCircuit: CustomCircuitCreateAdmin, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (customCircuit === null || customCircuit === undefined) {
            throw new Error('Required parameter customCircuit was null or undefined when calling adminPutCustomCircuitSysAdmin.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPutCustomCircuitSysAdmin.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<IvCertGenericResponseCustomCircuitCreateAdmin>(`${this.basePath}/api/${this.apiVersion}/Admin/CustomCircuit`,
            customCircuit,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update user in IvCert
     *
     * @param user User information
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPutUser(user: OrganizationUserP, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseOrganizationUserP>;
    public adminPutUser(user: OrganizationUserP, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseOrganizationUserP>>;
    public adminPutUser(user: OrganizationUserP, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseOrganizationUserP>>;
    public adminPutUser(user: OrganizationUserP, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (user === null || user === undefined) {
            throw new Error('Required parameter user was null or undefined when calling adminPutUser.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPutUser.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<IvCertGenericResponseOrganizationUserP>(`${this.basePath}/api/${this.apiVersion}/Admin/User`,
            user,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the list of users visible to the user
     *
     * @param authorization The authorization token
     * @param top The max number of records. (e.g. $top&#x3D;10)
     * @param skip The number of records to skip. (e.g. $skip&#x3D;5)
     * @param filter A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq &#39;bob&#39;)
     * @param select Specifies a subset of properties to return. (e.g. $select&#x3D;Name)
     * @param inlinecount Tells the server to include the total count of matching entities in the response. (e.g. $inlinecount&#x3D;allpages)
     * @param orderby Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGetListAllUser(authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'body', reportProgress?: boolean): Observable<OrganizationUserQ[]>;
    public userGetListAllUser(authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OrganizationUserQ[]>>;
    public userGetListAllUser(authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OrganizationUserQ[]>>;
    public userGetListAllUser(authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling userGetListAllUser.');
        }







        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (top !== undefined && top !== null) {
            queryParameters = queryParameters.set('$top', <any>top);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('$skip', <any>skip);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>filter);
        }
        if (select !== undefined && select !== null) {
            queryParameters = queryParameters.set('$select', <any>select);
        }
        if (inlinecount !== undefined && inlinecount !== null) {
            queryParameters = queryParameters.set('$inlinecount', <any>inlinecount);
        }
        if (orderby !== undefined && orderby !== null) {
            queryParameters = queryParameters.set('$orderby', <any>orderby);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<OrganizationUserQ[]>(`${this.basePath}/api/${this.apiVersion}/Admin/ListAllUser`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List all active areas organization
     *
     * @param idOrg
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetListActiveAreasOrg(idOrg: number, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListAreaP>;
    public adminGetListActiveAreasOrg(idOrg: number, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListAreaP>>;
    public adminGetListActiveAreasOrg(idOrg: number, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListAreaP>>;
    public adminGetListActiveAreasOrg(idOrg: number, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idOrg === null || idOrg === undefined) {
            throw new Error('Required parameter idOrg was null or undefined when calling adminGetListActiveAreasOrg.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetListActiveAreasOrg.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOrg !== undefined && idOrg !== null) {
            queryParameters = queryParameters.set('idOrg', <any>idOrg);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListAreaP>(`${this.basePath}/api/${this.apiVersion}/Admin/ListActiveAreasOrg`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List all active positions organization
     *
     * @param idOrg
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetListActivePositionsOrg(idOrg: number, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListCargo>;
    public adminGetListActivePositionsOrg(idOrg: number, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListCargo>>;
    public adminGetListActivePositionsOrg(idOrg: number, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListCargo>>;
    public adminGetListActivePositionsOrg(idOrg: number, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idOrg === null || idOrg === undefined) {
            throw new Error('Required parameter idOrg was null or undefined when calling adminGetListActivePositionsOrg.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetListActivePositionsOrg.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOrg !== undefined && idOrg !== null) {
            queryParameters = queryParameters.set('idOrg', <any>idOrg);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListCargo>(`${this.basePath}/api/${this.apiVersion}/Admin/ListActivePositionsOrg`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param idCircuit
     * @param idOperation
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetReprocessCallbackNotification(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminGetReprocessCallbackNotification(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminGetReprocessCallbackNotification(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminGetReprocessCallbackNotification(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idCircuit === null || idCircuit === undefined) {
            throw new Error('Required parameter idCircuit was null or undefined when calling adminGetReprocessCallbackNotification.');
        }

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling adminGetReprocessCallbackNotification.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetReprocessCallbackNotification.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idCircuit !== undefined && idCircuit !== null) {
            queryParameters = queryParameters.set('idCircuit', <any>idCircuit);
        }
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/ReprocessCallbackNotification`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param idCircuit
     * @param authorization The authorization token
     * @param idOperation
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetReprocessCallbacksCircuit(idCircuit: string, authorization: string, idOperation?: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminGetReprocessCallbacksCircuit(idCircuit: string, authorization: string, idOperation?: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminGetReprocessCallbacksCircuit(idCircuit: string, authorization: string, idOperation?: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminGetReprocessCallbacksCircuit(idCircuit: string, authorization: string, idOperation?: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idCircuit === null || idCircuit === undefined) {
            throw new Error('Required parameter idCircuit was null or undefined when calling adminGetReprocessCallbacksCircuit.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetReprocessCallbacksCircuit.');
        }



        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idCircuit !== undefined && idCircuit !== null) {
            queryParameters = queryParameters.set('idCircuit', <any>idCircuit);
        }
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/ReprocessCallbacksCircuit`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get user in IvCert
     *
     * @param idUser User identifier
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetUser(idUser: number, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseOrganizationUserP>;
    public adminGetUser(idUser: number, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseOrganizationUserP>>;
    public adminGetUser(idUser: number, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseOrganizationUserP>>;
    public adminGetUser(idUser: number, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idUser === null || idUser === undefined) {
            throw new Error('Required parameter idUser was null or undefined when calling adminGetUser.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetUser.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idUser !== undefined && idUser !== null) {
            queryParameters = queryParameters.set('idUser', <any>idUser);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseOrganizationUserP>(`${this.basePath}/api/${this.apiVersion}/Admin/User`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
    * Delete the relationship between operations and credits
     *
     * @param id id
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminDeleteRelationOperationCredits(id: number, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminDeleteRelationOperationCredits(id: number, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminDeleteRelationOperationCredits(id: number, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminDeleteRelationOperationCredits(id: number, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling adminDeleteRelationOperationCredits.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminDeleteRelationOperationCredits.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.delete<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/RelationOperationCredits`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
        );
    }

    /**
    *
     *
     * @param idCircuit
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetOperationsCircuitSysAdmin(idCircuit: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListOperationP>;
    public adminGetOperationsCircuitSysAdmin(idCircuit: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListOperationP>>;
    public adminGetOperationsCircuitSysAdmin(idCircuit: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListOperationP>>;
    public adminGetOperationsCircuitSysAdmin(idCircuit: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idCircuit === null || idCircuit === undefined) {
            throw new Error('Required parameter idCircuit was null or undefined when calling adminGetOperationsCircuitSysAdmin.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetOperationsCircuitSysAdmin.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

        if (idCircuit !== undefined && idCircuit !== null) {
            queryParameters = queryParameters.set('idCircuit', <any>idCircuit);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListOperationP>(`${this.basePath}/api/${this.apiVersion}/Admin/GetOperationsCircuitSysAdmin`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetDetailRelationOperationCredits(id: number, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseRelationOperationCredits>;
    public adminGetDetailRelationOperationCredits(id: number, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseRelationOperationCredits>>;
    public adminGetDetailRelationOperationCredits(id: number, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseRelationOperationCredits>>;
    public adminGetDetailRelationOperationCredits(id: number, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling adminGetDetailRelationOperationCredits.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetDetailRelationOperationCredits.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseRelationOperationCredits>(`${this.basePath}/api/${this.apiVersion}/Admin/DetailRelationOperationCredits`, {

            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
        );
    }

    /**
     * Get Organization SysAdmin
     *
     * @param idOrg Organization identifier
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetOrganization(idOrg: number, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseOrganizationPutAdmin>;
    public adminGetOrganization(idOrg: number, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseOrganizationPutAdmin>>;
    public adminGetOrganization(idOrg: number, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseOrganizationPutAdmin>>;
    public adminGetOrganization(idOrg: number, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idOrg === null || idOrg === undefined) {
            throw new Error('Required parameter idOrg was null or undefined when calling adminGetOrganization.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetOrganization.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOrg !== undefined && idOrg !== null) {
            queryParameters = queryParameters.set('idOrg', <any>idOrg);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseOrganizationPutAdmin>(`${this.basePath}/api/${this.apiVersion}/Admin/Organization`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
    * Create the relationship between operations and credits
    *
    * @param typeCircuit typeCircuit
    * @param typeOperation typeOperation
    * @param credits credits
    * @param authorization The authorization token
    * @param apiVersion
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public adminPostRelationOperationCredits(typeCircuit: string, typeOperation: string, credits: number, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminPostRelationOperationCredits(typeCircuit: string, typeOperation: string, credits: number, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminPostRelationOperationCredits(typeCircuit: string, typeOperation: string, credits: number, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminPostRelationOperationCredits(typeCircuit: string, typeOperation: string, credits: number, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (typeCircuit === null || typeCircuit === undefined) {
            throw new Error('Required parameter typeCircuit was null or undefined when calling adminPostRelationOperationCredits.');
        }

        if (typeOperation === null || typeOperation === undefined) {
            throw new Error('Required parameter typeOperation was null or undefined when calling adminPostRelationOperationCredits.');
        }

        if (credits === null || credits === undefined) {
            throw new Error('Required parameter credits was null or undefined when calling adminPostRelationOperationCredits.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPostRelationOperationCredits.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (typeCircuit !== undefined && typeCircuit !== null) {
            queryParameters = queryParameters.set('typeCircuit', <any>typeCircuit);
        }
        if (typeOperation !== undefined && typeOperation !== null) {
            queryParameters = queryParameters.set('typeOperation', <any>typeOperation);
        }
        if (credits !== undefined && credits !== null) {
            queryParameters = queryParameters.set('credits', <any>credits);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.post<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/RelationOperationCredits`,
            null, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
        );
    }

    /**
    * Return list of types templates
    *
    * @param authorization The authorization token
    * @param apiVersion
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public adminGetTypesTemplates(authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListIvcertTypeTemplate>;
    public adminGetTypesTemplates(authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListIvcertTypeTemplate>>;
    public adminGetTypesTemplates(authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListIvcertTypeTemplate>>;
    public adminGetTypesTemplates(authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetTypesTemplates.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListIvcertTypeTemplate>(`${this.basePath}/api/${this.apiVersion}/Admin/GetTypesTemplates`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
         * Get all operation types
         *
         * @param authorization The authorization token
         * @param apiVersion
         * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
         * @param reportProgress flag to report request and response progress.
         */
    public adminGetListOperationTypes(authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListOperationType>;
    public adminGetListOperationTypes(authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListOperationType>>;
    public adminGetListOperationTypes(authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListOperationType>>;
    public adminGetListOperationTypes(authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetListOperationTypes.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListOperationType>(`${this.basePath}/api/${this.apiVersion}/Admin/GetListOperationTypes`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param authorization The authorization token
     * @param appId
     * @param idOrg
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetTypesCircuit(authorization: string, appId?: string, idOrg?: number, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListAdminTypesCircuits>;
    public adminGetTypesCircuit(authorization: string, appId?: string, idOrg?: number, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListAdminTypesCircuits>>;
    public adminGetTypesCircuit(authorization: string, appId?: string, idOrg?: number, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListAdminTypesCircuits>>;
    public adminGetTypesCircuit(authorization: string, appId?: string, idOrg?: number, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetTypesCircuit.');
        }




        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (appId !== undefined && appId !== null) {
            queryParameters = queryParameters.set('appId', <any>appId);
        }
        if (idOrg !== undefined && idOrg !== null) {
            queryParameters = queryParameters.set('idOrg', <any>idOrg);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListAdminTypesCircuits>(`${this.basePath}/api/${this.apiVersion}/Admin/GetTypesCircuit`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
    * Update the relationship between operations and credits
    *
    * @param typeCircuit typeCircuit
    * @param typeOperation typeOperation
    * @param credits credits
    * @param authorization The authorization token
    * @param id credits
    * @param apiVersion
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public adminPutRelationOperationCredits(typeCircuit: string, typeOperation: string, credits: number, authorization: string, id?: number, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminPutRelationOperationCredits(typeCircuit: string, typeOperation: string, credits: number, authorization: string, id?: number, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminPutRelationOperationCredits(typeCircuit: string, typeOperation: string, credits: number, authorization: string, id?: number, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminPutRelationOperationCredits(typeCircuit: string, typeOperation: string, credits: number, authorization: string, id?: number, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (typeCircuit === null || typeCircuit === undefined) {
            throw new Error('Required parameter typeCircuit was null or undefined when calling adminPutRelationOperationCredits.');
        }

        if (typeOperation === null || typeOperation === undefined) {
            throw new Error('Required parameter typeOperation was null or undefined when calling adminPutRelationOperationCredits.');
        }

        if (credits === null || credits === undefined) {
            throw new Error('Required parameter credits was null or undefined when calling adminPutRelationOperationCredits.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPutRelationOperationCredits.');
        }



        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (typeCircuit !== undefined && typeCircuit !== null) {
            queryParameters = queryParameters.set('typeCircuit', <any>typeCircuit);
        }
        if (typeOperation !== undefined && typeOperation !== null) {
            queryParameters = queryParameters.set('typeOperation', <any>typeOperation);
        }
        if (credits !== undefined && credits !== null) {
            queryParameters = queryParameters.set('credits', <any>credits);
        }
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.put<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/RelationOperationCredits`,
            null, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
        );
    }

    /**
     * Get organization list without ODataQuery object
     *
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetListOrganizations(authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListAdminOrga>;
    public adminGetListOrganizations(authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListAdminOrga>>;
    public adminGetListOrganizations(authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListAdminOrga>>;
    public adminGetListOrganizations(authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetListOrganizations.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListAdminOrga>(`${this.basePath}/api/${this.apiVersion}/Admin/GetListOrganizations`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get customization list without ODataQuery object
     *
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetCustomizationList(authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListListCustomizationTemplates>;
    public adminGetCustomizationList(authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListListCustomizationTemplates>>;
    public adminGetCustomizationList(authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListListCustomizationTemplates>>;
    public adminGetCustomizationList(authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetCustomizationList.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListListCustomizationTemplates>(`${this.basePath}/api/${this.apiVersion}/Admin/GetCustomizationsList`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create new template
     *
     * @param request
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPostCreateTemplate(request: AdminRequestPostTemplate, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseAdminRequestPostTemplate>;
    public adminPostCreateTemplate(request: AdminRequestPostTemplate, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseAdminRequestPostTemplate>>;
    public adminPostCreateTemplate(request: AdminRequestPostTemplate, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseAdminRequestPostTemplate>>;
    public adminPostCreateTemplate(request: AdminRequestPostTemplate, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling adminPostCreateTemplate.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPostCreateTemplate.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvCertGenericResponseAdminRequestPostTemplate>(`${this.basePath}/api/${this.apiVersion}/Admin/CreateTemplate`,
            request,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete template (logic, set dateDisable now)
     *
     * @param id
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminDeleteTemplate(id: number, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminDeleteTemplate(id: number, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminDeleteTemplate(id: number, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminDeleteTemplate(id: number, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling adminDeleteTemplate.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminDeleteTemplate.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.delete<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/DeleteTemplate/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param request
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPutUpdateTemplate(request: AdminRequestPostTemplate, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseAdminRequestPostTemplate>;
    public adminPutUpdateTemplate(request: AdminRequestPostTemplate, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseAdminRequestPostTemplate>>;
    public adminPutUpdateTemplate(request: AdminRequestPostTemplate, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseAdminRequestPostTemplate>>;
    public adminPutUpdateTemplate(request: AdminRequestPostTemplate, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling adminPutUpdateTemplate.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPutUpdateTemplate.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<IvCertGenericResponseAdminRequestPostTemplate>(`${this.basePath}/api/${this.apiVersion}/Admin/UpdateTemplate`,
            request,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Insert new prefix
     *
     * @param prefix
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPostNewPrefix(prefix: OrganizationPhonePrefix, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseOrganizationPhonePrefix>;
    public adminPostNewPrefix(prefix: OrganizationPhonePrefix, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseOrganizationPhonePrefix>>;
    public adminPostNewPrefix(prefix: OrganizationPhonePrefix, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseOrganizationPhonePrefix>>;
    public adminPostNewPrefix(prefix: OrganizationPhonePrefix, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (prefix === null || prefix === undefined) {
            throw new Error('Required parameter prefix was null or undefined when calling adminPostNewPrefix.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPostNewPrefix.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvGenericRestResponseOrganizationPhonePrefix>(`${this.basePath}/api/${this.apiVersion}/Admin/Prefixes`,
            prefix,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update prefix
     *
     * @param prefix
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPutPrefix(prefix: OrganizationPhonePrefix, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseOrganizationPhonePrefix>;
    public adminPutPrefix(prefix: OrganizationPhonePrefix, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseOrganizationPhonePrefix>>;
    public adminPutPrefix(prefix: OrganizationPhonePrefix, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseOrganizationPhonePrefix>>;
    public adminPutPrefix(prefix: OrganizationPhonePrefix, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (prefix === null || prefix === undefined) {
            throw new Error('Required parameter prefix was null or undefined when calling adminPutPrefix.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPutPrefix.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<IvGenericRestResponseOrganizationPhonePrefix>(`${this.basePath}/api/${this.apiVersion}/Admin/Prefixes`,
            prefix,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete prefix
     *
     * @param idPrefix
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminDeletePrefix(idPrefix: number, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminDeletePrefix(idPrefix: number, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminDeletePrefix(idPrefix: number, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminDeletePrefix(idPrefix: number, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idPrefix === null || idPrefix === undefined) {
            throw new Error('Required parameter idPrefix was null or undefined when calling adminDeletePrefix.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminDeletePrefix.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idPrefix !== undefined && idPrefix !== null) {
            queryParameters = queryParameters.set('idPrefix', <any>idPrefix);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.delete<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/Prefixes`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


    /**
     * Get all prefixes
     *
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetAllPrefix(authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseListOrganizationPhonePrefix>;
    public adminGetAllPrefix(authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseListOrganizationPhonePrefix>>;
    public adminGetAllPrefix(authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseListOrganizationPhonePrefix>>;
    public adminGetAllPrefix(authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetAllPrefix.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        if (this.prefixesCache$) {
            return this.prefixesCache$;
        }

        return this.httpClient.get<IvGenericRestResponseListOrganizationPhonePrefix>(`${this.basePath}/api/${this.apiVersion}/Admin/Prefixes`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).pipe(
            tap((prefixes) => this.prefixesCache$ = of(prefixes)),
        )
    }

    /**
    * Get prefix by id
    *
    * @param idPrefix
    * @param authorization The authorization token
    * @param apiVersion
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public adminGetPrefixbyId(idPrefix: number, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseOrganizationPhonePrefix>;
    public adminGetPrefixbyId(idPrefix: number, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseOrganizationPhonePrefix>>;
    public adminGetPrefixbyId(idPrefix: number, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseOrganizationPhonePrefix>>;
    public adminGetPrefixbyId(idPrefix: number, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idPrefix === null || idPrefix === undefined) {
            throw new Error('Required parameter idPrefix was null or undefined when calling adminGetPrefixbyId.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetPrefixbyId.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idPrefix !== undefined && idPrefix !== null) {
            queryParameters = queryParameters.set('idPrefix', <any>idPrefix);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvGenericRestResponseOrganizationPhonePrefix>(`${this.basePath}/api/${this.apiVersion}/Admin/Prefixes/GetPrefixByID`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return specific template
     *
     * @param idTemplate
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetTemplate(idTemplate: number, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseIvcertTemplates>;
    public adminGetTemplate(idTemplate: number, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseIvcertTemplates>>;
    public adminGetTemplate(idTemplate: number, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseIvcertTemplates>>;
    public adminGetTemplate(idTemplate: number, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idTemplate === null || idTemplate === undefined) {
            throw new Error('Required parameter idTemplate was null or undefined when calling adminGetTemplate.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetTemplate.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idTemplate !== undefined && idTemplate !== null) {
            queryParameters = queryParameters.set('idTemplate', <any>idTemplate);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseIvcertTemplates>(`${this.basePath}/api/${this.apiVersion}/Admin/GetTemplate`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param idAccess
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminDeleteAccessRestrictions(idAccess: number, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminDeleteAccessRestrictions(idAccess: number, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminDeleteAccessRestrictions(idAccess: number, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminDeleteAccessRestrictions(idAccess: number, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idAccess === null || idAccess === undefined) {
            throw new Error('Required parameter idAccess was null or undefined when calling adminDeleteAccessRestrictions.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminDeleteAccessRestrictions.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idAccess !== undefined && idAccess !== null) {
            queryParameters = queryParameters.set('idAccess', <any>idAccess);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.delete<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/AccessRestrictions`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


    /**
     *
     *
     * @param idAccess
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetAccessRestriction(idAccess: number, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseAccessRestrictions>;
    public adminGetAccessRestriction(idAccess: number, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseAccessRestrictions>>;
    public adminGetAccessRestriction(idAccess: number, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseAccessRestrictions>>;
    public adminGetAccessRestriction(idAccess: number, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idAccess === null || idAccess === undefined) {
            throw new Error('Required parameter idAccess was null or undefined when calling adminGetAccessRestriction.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetAccessRestriction.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idAccess !== undefined && idAccess !== null) {
            queryParameters = queryParameters.set('idAccess', <any>idAccess);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseAccessRestrictions>(`${this.basePath}/api/${this.apiVersion}/Admin/AccessRestrictions`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetAllCircuitTypes(authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseListCircuitTypeListResponse>;
    public adminGetAllCircuitTypes(authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseListCircuitTypeListResponse>>;
    public adminGetAllCircuitTypes(authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseListCircuitTypeListResponse>>;
    public adminGetAllCircuitTypes(authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetAllCircuitTypes.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<IvGenericRestResponseListCircuitTypeListResponse>(`${this.basePath}/api/${this.apiVersion}/Admin/AllCircuitTypes`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param accessRestriction
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPostAccessRestrictions(accessRestriction: AccessRestrictions, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseAccessRestrictions>;
    public adminPostAccessRestrictions(accessRestriction: AccessRestrictions, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseAccessRestrictions>>;
    public adminPostAccessRestrictions(accessRestriction: AccessRestrictions, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseAccessRestrictions>>;
    public adminPostAccessRestrictions(accessRestriction: AccessRestrictions, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (accessRestriction === null || accessRestriction === undefined) {
            throw new Error('Required parameter accessRestriction was null or undefined when calling adminPostAccessRestrictions.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPostAccessRestrictions.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvGenericRestResponseAccessRestrictions>(`${this.basePath}/api/${this.apiVersion}/Admin/AccessRestrictions`,
            accessRestriction,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param accessRestriction
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPutAccessRestrictions(accessRestriction: AccessRestrictions, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminPutAccessRestrictions(accessRestriction: AccessRestrictions, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminPutAccessRestrictions(accessRestriction: AccessRestrictions, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminPutAccessRestrictions(accessRestriction: AccessRestrictions, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (accessRestriction === null || accessRestriction === undefined) {
            throw new Error('Required parameter accessRestriction was null or undefined when calling adminPutAccessRestrictions.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPutAccessRestrictions.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/AccessRestrictions`,
            accessRestriction,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetListOrganizationsAccessLogin(authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListOrgaAccessLogin>;
    public adminGetListOrganizationsAccessLogin(authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListOrgaAccessLogin>>;
    public adminGetListOrganizationsAccessLogin(authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListOrgaAccessLogin>>;
    public adminGetListOrganizationsAccessLogin(authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetListOrganizationsAccessLogin.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListOrgaAccessLogin>(`${this.basePath}/api/${this.apiVersion}/Admin/GetListOrganizationsAccessLogin`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param idCircuit
     * @param idOperation
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetReprocessSIGAUTSysAdmin(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminGetReprocessSIGAUTSysAdmin(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminGetReprocessSIGAUTSysAdmin(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminGetReprocessSIGAUTSysAdmin(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idCircuit === null || idCircuit === undefined) {
            throw new Error('Required parameter idCircuit was null or undefined when calling adminGetReprocessSIGAUTSysAdmin.');
        }

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling adminGetReprocessSIGAUTSysAdmin.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetReprocessSIGAUTSysAdmin.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idCircuit !== undefined && idCircuit !== null) {
            queryParameters = queryParameters.set('idCircuit', <any>idCircuit);
        }
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/ReprocessSIGAUT`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param idCircuit
     * @param idOperation
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetReprocessSIGORGASysAdmin(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminGetReprocessSIGORGASysAdmin(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminGetReprocessSIGORGASysAdmin(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminGetReprocessSIGORGASysAdmin(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idCircuit === null || idCircuit === undefined) {
            throw new Error('Required parameter idCircuit was null or undefined when calling adminGetReprocessSIGORGASysAdmin.');
        }

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling adminGetReprocessSIGORGASysAdmin.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetReprocessSIGORGASysAdmin.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idCircuit !== undefined && idCircuit !== null) {
            queryParameters = queryParameters.set('idCircuit', <any>idCircuit);
        }
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/ReprocessSIGORGA`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
    *
    *
    * @param authorization The authorization token
    * @param apiVersion
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public adminGetListAllCreators(authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<UserCreator>>;
    public adminGetListAllCreators(authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserCreator>>>;
    public adminGetListAllCreators(authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserCreator>>>;
    public adminGetListAllCreators(authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetListAllCreators.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<Array<UserCreator>>(`${this.basePath}/api/${this.apiVersion}/Admin/ListAllCreators`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param Authorization The authorization token
     * @param top The max number of records. (e.g. $top&#x3D;10)
     * @param skip The number of records to skip. (e.g. $skip&#x3D;5)
     * @param filter A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq &#39;bob&#39;)
     * @param select Specifies a subset of properties to return. (e.g. $select&#x3D;Name)
     * @param inlinecount Tells the server to include the total count of matching entities in the response. (e.g. $inlinecount&#x3D;allpages)
     * @param orderby Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetListSignatureOrganizationCertificate(Authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'body', reportProgress?: boolean): Observable<PageResultItemSignatureCertificateResponse>;
    public adminGetListSignatureOrganizationCertificate(Authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageResultItemSignatureCertificateResponse>>;
    public adminGetListSignatureOrganizationCertificate(Authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageResultItemSignatureCertificateResponse>>;
    public adminGetListSignatureOrganizationCertificate(Authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling adminGetListSignatureOrganizationCertificate.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (top !== undefined && top !== null) {
            queryParameters = queryParameters.set('$top', <any>top);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('$skip', <any>skip);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>filter);
        }
        if (select !== undefined && select !== null) {
            queryParameters = queryParameters.set('$select', <any>select);
        }
        if (inlinecount !== undefined && inlinecount !== null) {
            queryParameters = queryParameters.set('$inlinecount', <any>inlinecount);
        }
        if (orderby !== undefined && orderby !== null) {
            queryParameters = queryParameters.set('$orderby', <any>orderby);
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PageResultItemSignatureCertificateResponse>(`${this.basePath}/api/${this.apiVersion}/Admin/ListSignatureOrganizationCertificate`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
    *
    *
    * @param certId
    * @param Authorization The authorization token
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public adminDeleteSignatureOrganizationCertificate(certId: string, Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminDeleteSignatureOrganizationCertificate(certId: string, Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminDeleteSignatureOrganizationCertificate(certId: string, Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminDeleteSignatureOrganizationCertificate(certId: string, Authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (certId === null || certId === undefined) {
            throw new Error('Required parameter certId was null or undefined when calling adminDeleteSignatureOrganizationCertificate.');
        }

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling adminDeleteSignatureOrganizationCertificate.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (certId !== undefined && certId !== null) {
            queryParameters = queryParameters.set('certId', <any>certId);
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/DeleteSigOrgaCertificate`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param certId
     * @param Authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetSignatureOrganizationCertificate(certId: string, Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseItemSignatureCertificateResponse>;
    public adminGetSignatureOrganizationCertificate(certId: string, Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseItemSignatureCertificateResponse>>;
    public adminGetSignatureOrganizationCertificate(certId: string, Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseItemSignatureCertificateResponse>>;
    public adminGetSignatureOrganizationCertificate(certId: string, Authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (certId === null || certId === undefined) {
            throw new Error('Required parameter certId was null or undefined when calling adminGetSignatureOrganizationCertificate.');
        }

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling adminGetSignatureOrganizationCertificate.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (certId !== undefined && certId !== null) {
            queryParameters = queryParameters.set('certId', <any>certId);
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<IvCertGenericResponseItemSignatureCertificateResponse>(`${this.basePath}/api/${this.apiVersion}/Admin/GetSigOrgaCertificate`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create new certificate in organization for SIGORGA operation
     *
     * @param cert
     * @param Authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPostSignatureOrganizationCertificate(cert: SigorgaCerts, Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseSigorgaCerts>;
    public adminPostSignatureOrganizationCertificate(cert: SigorgaCerts, Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseSigorgaCerts>>;
    public adminPostSignatureOrganizationCertificate(cert: SigorgaCerts, Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseSigorgaCerts>>;
    public adminPostSignatureOrganizationCertificate(cert: SigorgaCerts, Authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (cert === null || cert === undefined) {
            throw new Error('Required parameter cert was null or undefined when calling adminPostSignatureOrganizationCertificate.');
        }

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling adminPostSignatureOrganizationCertificate.');
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvCertGenericResponseSigorgaCerts>(`${this.basePath}/api/${this.apiVersion}/Admin/PostSigOrgaCertificate`,
            cert,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
    * Update certificate in organization for SIGORGA operation
    *
    * @param cert
    * @param Authorization The authorization token
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public adminPutSignatureOrganizationCertificate(cert: SigorgaCerts, Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminPutSignatureOrganizationCertificate(cert: SigorgaCerts, Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminPutSignatureOrganizationCertificate(cert: SigorgaCerts, Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminPutSignatureOrganizationCertificate(cert: SigorgaCerts, Authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (cert === null || cert === undefined) {
            throw new Error('Required parameter cert was null or undefined when calling adminPutSignatureOrganizationCertificate.');
        }

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling adminPutSignatureOrganizationCertificate.');
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/UpdateSigOrgaCertificate`,
            cert,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param senderId
     * @param Authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminDeleteSender(senderId: number, Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminDeleteSender(senderId: number, Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminDeleteSender(senderId: number, Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminDeleteSender(senderId: number, Authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (senderId === null || senderId === undefined) {
            throw new Error('Required parameter senderId was null or undefined when calling adminDeleteSender.');
        }

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling adminDeleteSender.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (senderId !== undefined && senderId !== null) {
            queryParameters = queryParameters.set('senderId', <any>senderId);
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/Sender`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param senderId
     * @param Authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetSender(senderId: number, Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseItemOrganizationSenderResponse>;
    public adminGetSender(senderId: number, Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseItemOrganizationSenderResponse>>;
    public adminGetSender(senderId: number, Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseItemOrganizationSenderResponse>>;
    public adminGetSender(senderId: number, Authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (senderId === null || senderId === undefined) {
            throw new Error('Required parameter senderId was null or undefined when calling adminGetSender.');
        }

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling adminGetSender.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (senderId !== undefined && senderId !== null) {
            queryParameters = queryParameters.set('senderId', <any>senderId);
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<IvCertGenericResponseItemOrganizationSenderResponse>(`${this.basePath}/api/${this.apiVersion}/Admin/Sender`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param Authorization The authorization token
     * @param top The max number of records. (e.g. $top&#x3D;10)
     * @param skip The number of records to skip. (e.g. $skip&#x3D;5)
     * @param filter A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq &#39;bob&#39;)
     * @param select Specifies a subset of properties to return. (e.g. $select&#x3D;Name)
     * @param inlinecount Tells the server to include the total count of matching entities in the response. (e.g. $inlinecount&#x3D;allpages)
     * @param orderby Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetSenderList(Authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'body', reportProgress?: boolean): Observable<PageResultItemOrganizationSenderResponse>;
    public adminGetSenderList(Authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageResultItemOrganizationSenderResponse>>;
    public adminGetSenderList(Authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageResultItemOrganizationSenderResponse>>;
    public adminGetSenderList(Authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling adminGetSenderList.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (top !== undefined && top !== null) {
            queryParameters = queryParameters.set('$top', <any>top);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('$skip', <any>skip);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>filter);
        }
        if (select !== undefined && select !== null) {
            queryParameters = queryParameters.set('$select', <any>select);
        }
        if (inlinecount !== undefined && inlinecount !== null) {
            queryParameters = queryParameters.set('$inlinecount', <any>inlinecount);
        }
        if (orderby !== undefined && orderby !== null) {
            queryParameters = queryParameters.set('$orderby', <any>orderby);
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PageResultItemOrganizationSenderResponse>(`${this.basePath}/api/${this.apiVersion}/Admin/GetSenderList`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param Authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetSenderTypes(Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListString>;
    public adminGetSenderTypes(Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListString>>;
    public adminGetSenderTypes(Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListString>>;
    public adminGetSenderTypes(Authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling adminGetSenderTypes.');
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<IvCertGenericResponseListString>(`${this.basePath}/api/${this.apiVersion}/Admin/GetSenderTypes`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create sender for organization
     *
     * @param request
     * @param Authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPostSender(request: CreateOrganizationSenderRequest, Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminPostSender(request: CreateOrganizationSenderRequest, Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminPostSender(request: CreateOrganizationSenderRequest, Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminPostSender(request: CreateOrganizationSenderRequest, Authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling adminPostSender.');
        }

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling adminPostSender.');
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/Sender`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update sender for organization
     *
     * @param request
     * @param Authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPutSender(request: UpdateOrganizationSenderRequest, Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminPutSender(request: UpdateOrganizationSenderRequest, Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminPutSender(request: UpdateOrganizationSenderRequest, Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminPutSender(request: UpdateOrganizationSenderRequest, Authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling adminPutSender.');
        }

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling adminPutSender.');
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/Sender`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
    *
    *
    * @param id
    * @param Authorization The authorization token
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public adminGetReprocessCallbackPolicy(id: number, Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseItemReprocessCallbackPolicyResponse>;
    public adminGetReprocessCallbackPolicy(id: number, Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseItemReprocessCallbackPolicyResponse>>;
    public adminGetReprocessCallbackPolicy(id: number, Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseItemReprocessCallbackPolicyResponse>>;
    public adminGetReprocessCallbackPolicy(id: number, Authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling adminGetReprocessCallbackPolicy.');
        }

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling adminGetReprocessCallbackPolicy.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<IvCertGenericResponseItemReprocessCallbackPolicyResponse>(`${this.basePath}/api/${this.apiVersion}/Admin/ReprocessCallbackPolicy`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param Authorization The authorization token
     * @param top The max number of records. (e.g. $top&#x3D;10)
     * @param skip The number of records to skip. (e.g. $skip&#x3D;5)
     * @param filter A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq &#39;bob&#39;)
     * @param select Specifies a subset of properties to return. (e.g. $select&#x3D;Name)
     * @param inlinecount Tells the server to include the total count of matching entities in the response. (e.g. $inlinecount&#x3D;allpages)
     * @param orderby Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetReprocessCallbackPolicyList(Authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'body', reportProgress?: boolean): Observable<PageResultItemReprocessCallbackPolicyResponse>;
    public adminGetReprocessCallbackPolicyList(Authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageResultItemReprocessCallbackPolicyResponse>>;
    public adminGetReprocessCallbackPolicyList(Authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageResultItemReprocessCallbackPolicyResponse>>;
    public adminGetReprocessCallbackPolicyList(Authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling adminGetReprocessCallbackPolicyList.');
        }
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (top !== undefined && top !== null) {
            queryParameters = queryParameters.set('$top', <any>top);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('$skip', <any>skip);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>filter);
        }
        if (select !== undefined && select !== null) {
            queryParameters = queryParameters.set('$select', <any>select);
        }
        if (inlinecount !== undefined && inlinecount !== null) {
            queryParameters = queryParameters.set('$inlinecount', <any>inlinecount);
        }
        if (orderby !== undefined && orderby !== null) {
            queryParameters = queryParameters.set('$orderby', <any>orderby);
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PageResultItemReprocessCallbackPolicyResponse>(`${this.basePath}/api/${this.apiVersion}/Admin/ReprocessCallbackPolicyList`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
    *
    *
    * @param request
    * @param Authorization The authorization token
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public adminPostReprocessCallbackPolicy(request: CreateReprocessCallbackPolicyRequest, Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminPostReprocessCallbackPolicy(request: CreateReprocessCallbackPolicyRequest, Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminPostReprocessCallbackPolicy(request: CreateReprocessCallbackPolicyRequest, Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminPostReprocessCallbackPolicy(request: CreateReprocessCallbackPolicyRequest, Authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling adminPostReprocessCallbackPolicy.');
        }

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling adminPostReprocessCallbackPolicy.');
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/ReprocessCallbackPolicy`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param request
     * @param Authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPutReprocessCallbackPolicy(request: UpdateReprocessCallbackPolicyRequest, Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminPutReprocessCallbackPolicy(request: UpdateReprocessCallbackPolicyRequest, Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminPutReprocessCallbackPolicy(request: UpdateReprocessCallbackPolicyRequest, Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminPutReprocessCallbackPolicy(request: UpdateReprocessCallbackPolicyRequest, Authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling adminPutReprocessCallbackPolicy.');
        }

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling adminPutReprocessCallbackPolicy.');
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/ReprocessCallbackPolicy`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
    /**
     * Retrieves document extensions supported for signing.
     *
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetDocumentExtensionSupportedForSignings(authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseIEnumerableString>;
    public adminGetDocumentExtensionSupportedForSignings(authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseIEnumerableString>>;
    public adminGetDocumentExtensionSupportedForSignings(authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseIEnumerableString>>;
    public adminGetDocumentExtensionSupportedForSignings(authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetDocumentExtensionSupportedForSignings.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<IvCertGenericResponseIEnumerableString>(`${this.basePath}/api/${this.apiVersion}/Admin/GetTypeDocTypeSignature`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves the signature type for a specific type.
     *
     * @param code The code of signature type.
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetSignatureType(code: string, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseGetSignatureTypeResponse>;
    public adminGetSignatureType(code: string, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseGetSignatureTypeResponse>>;
    public adminGetSignatureType(code: string, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseGetSignatureTypeResponse>>;
    public adminGetSignatureType(code: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling adminGetSignatureType.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetSignatureType.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (code !== undefined && code !== null) {
            queryParameters = queryParameters.set('code', <any>code);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<IvCertGenericResponseGetSignatureTypeResponse>(`${this.basePath}/api/${this.apiVersion}/Admin/TypeSignature`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a signature type.
     *
     * @param request
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPostSignatureType(request: CreateSignatureTypeRequest, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public adminPostSignatureType(request: CreateSignatureTypeRequest, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public adminPostSignatureType(request: CreateSignatureTypeRequest, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public adminPostSignatureType(request: CreateSignatureTypeRequest, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling adminPostSignatureType.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPostSignatureType.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/api/${this.apiVersion}/Admin/TypeSignature`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a signature type.
     *
     * @param code
     * @param request
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPutSignatureType(code: string, request: UpdateSignatureTypeRequest, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public adminPutSignatureType(code: string, request: UpdateSignatureTypeRequest, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public adminPutSignatureType(code: string, request: UpdateSignatureTypeRequest, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public adminPutSignatureType(code: string, request: UpdateSignatureTypeRequest, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling adminPutSignatureType.');
        }

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling adminPutSignatureType.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPutSignatureType.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (code !== undefined && code !== null) {
            queryParameters = queryParameters.set('code', <any>code);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/api/${this.apiVersion}/Admin/TypeSignature`,
            request,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deletes a signature type with the specified type signature code.
     *
     * @param code The code of the signature type to delete.
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminDeleteSignatureType(code: string, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public adminDeleteSignatureType(code: string, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public adminDeleteSignatureType(code: string, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public adminDeleteSignatureType(code: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling adminDeleteSignatureType.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminDeleteSignatureType.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (code !== undefined && code !== null) {
            queryParameters = queryParameters.set('code', <any>code);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/${this.apiVersion}/Admin/TypeSignature`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves a collection of signature types filtering by document type.
     *
     * @param documentType The document type to filter.
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetSignatureTypeListByDocumentType(documentType: string, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseIListItemSignatureTypesByTypeDocResponse>;
    public adminGetSignatureTypeListByDocumentType(documentType: string, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseIListItemSignatureTypesByTypeDocResponse>>;
    public adminGetSignatureTypeListByDocumentType(documentType: string, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseIListItemSignatureTypesByTypeDocResponse>>;
    public adminGetSignatureTypeListByDocumentType(documentType: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (documentType === null || documentType === undefined) {
            throw new Error('Required parameter documentType was null or undefined when calling adminGetSignatureTypeListByDocumentType.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetSignatureTypeListByDocumentType.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (documentType !== undefined && documentType !== null) {
            queryParameters = queryParameters.set('documentType', <any>documentType);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<IvCertGenericResponseIListItemSignatureTypesByTypeDocResponse>(`${this.basePath}/api/${this.apiVersion}/Admin/GetTypeSignatureListByTypeDoc`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get Method to return a collection of terms and conditions.
     *
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetTermsAndConditionsList(authorization: string, observe?: 'body', reportProgress?: boolean): Observable<PageResultItemTermAndConditionResponse>;
    public adminGetTermsAndConditionsList(authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageResultItemTermAndConditionResponse>>;
    public adminGetTermsAndConditionsList(authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageResultItemTermAndConditionResponse>>;
    public adminGetTermsAndConditionsList(authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetTermsAndConditionsList.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PageResultItemTermAndConditionResponse>(`${this.basePath}/api/${this.apiVersion}/Admin/GetTermsAndConditionsList`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param request
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPostTermAndCondition(request: CreateTermAndConditionRequest, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public adminPostTermAndCondition(request: CreateTermAndConditionRequest, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public adminPostTermAndCondition(request: CreateTermAndConditionRequest, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public adminPostTermAndCondition(request: CreateTermAndConditionRequest, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling adminPostTermAndCondition.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPostTermAndCondition.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/api/${this.apiVersion}/Admin/TermsAndConditions`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves the terms and conditions for a specific ID.
     *
     * @param id The ID of the term and condition.
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetTermAndCondition(id: number, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseGetTermAndConditionResponse>;
    public adminGetTermAndCondition(id: number, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseGetTermAndConditionResponse>>;
    public adminGetTermAndCondition(id: number, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseGetTermAndConditionResponse>>;
    public adminGetTermAndCondition(id: number, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling adminGetTermAndCondition.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetTermAndCondition.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<IvCertGenericResponseGetTermAndConditionResponse>(`${this.basePath}/api/${this.apiVersion}/Admin/TermsAndConditions`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deletes a term and condition with the specified ID.
     *
     * @param id The ID of the term and condition to delete.
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminDeleteTermAndCondition(id: number, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public adminDeleteTermAndCondition(id: number, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public adminDeleteTermAndCondition(id: number, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public adminDeleteTermAndCondition(id: number, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling adminDeleteTermAndCondition.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminDeleteTermAndCondition.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/${this.apiVersion}/Admin/TermsAndConditions/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param request
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPutTermAndCondition(request: UpdateTermAndConditionRequest, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public adminPutTermAndCondition(request: UpdateTermAndConditionRequest, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public adminPutTermAndCondition(request: UpdateTermAndConditionRequest, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public adminPutTermAndCondition(request: UpdateTermAndConditionRequest, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling adminPutTermAndCondition.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPutTermAndCondition.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/api/${this.apiVersion}/Admin/TermsAndConditions`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get types widgets.
     *
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetTypesWidgets(authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListString>;
    public adminGetTypesWidgets(authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListString>>;
    public adminGetTypesWidgets(authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListString>>;
    public adminGetTypesWidgets(authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetTypesWidgets.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<IvCertGenericResponseListString>(`${this.basePath}/api/${this.apiVersion}/Admin/GetTypesWidgets`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create new widget
     *
     * @param widget
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPostWidget(widget: PostWidgetRequest, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminPostWidget(widget: PostWidgetRequest, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminPostWidget(widget: PostWidgetRequest, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminPostWidget(widget: PostWidgetRequest, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (widget === null || widget === undefined) {
            throw new Error('Required parameter widget was null or undefined when calling adminPostWidget.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPostWidget.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/Widget`,
            widget,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete widget
     *
     * @param widgetId
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminDeleteWidget(widgetId: number, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminDeleteWidget(widgetId: number, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminDeleteWidget(widgetId: number, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminDeleteWidget(widgetId: number, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (widgetId === null || widgetId === undefined) {
            throw new Error('Required parameter widgetId was null or undefined when calling adminDeleteWidget.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminDeleteWidget.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (widgetId !== undefined && widgetId !== null) {
            queryParameters = queryParameters.set('widgetId', <any>widgetId);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/Widget`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get widget by id
     *
     * @param widgetId
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminGetWidget(widgetId: number, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseGetWidgetResponse>;
    public adminGetWidget(widgetId: number, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseGetWidgetResponse>>;
    public adminGetWidget(widgetId: number, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseGetWidgetResponse>>;
    public adminGetWidget(widgetId: number, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (widgetId === null || widgetId === undefined) {
            throw new Error('Required parameter widgetId was null or undefined when calling adminGetWidget.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminGetWidget.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (widgetId !== undefined && widgetId !== null) {
            queryParameters = queryParameters.set('WidgetId', <any>widgetId);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<IvCertGenericResponseGetWidgetResponse>(`${this.basePath}/api/${this.apiVersion}/Admin/Widget`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update widget
     *
     * @param widget
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminPutWidget(widget: PutWidgetRequest, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public adminPutWidget(widget: PutWidgetRequest, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public adminPutWidget(widget: PutWidgetRequest, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public adminPutWidget(widget: PutWidgetRequest, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (widget === null || widget === undefined) {
            throw new Error('Required parameter widget was null or undefined when calling adminPutWidget.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling adminPutWidget.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Admin/Widget`,
            widget,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
